import { AloftDate, FormType, ReportJSON, isDefined } from '@aloft/toolkit-shared';

import { generateTkv2CostDataRptiNodes } from '../createTkv2CostDataRptiNodes.ts';
import { generateOrderInputRptiNodes } from '../generateOrderInputRptiNodes.ts';
import { generateTkv2AdjustmentsRptiNodes } from '../generateTkv2AdjustmentsRptiNodes.ts';
import { generateTkv2UADAnnotationRptiNodes } from '../generateTkv2UADAnnotationRptiNodes.ts';
import { SFREP_FNMA_1025_FORM_CODE } from './consts.ts';

export const create1025FormNode = (
  doc: XMLDocument,
  effectiveDate: AloftDate | undefined,
  compSequence: string[],
  { comps, subject, meta }: ReportJSON,
): HTMLElement => {
  const fnma1025 = doc.createElement('Form');
  fnma1025.setAttribute('Id', SFREP_FNMA_1025_FORM_CODE);

  const reportFields = doc.createElement('Fields');
  fnma1025.append(reportFields);

  if (isDefined(effectiveDate)) {
    reportFields.append(...generateOrderInputRptiNodes(doc, effectiveDate));
  }
  reportFields.append(
    ...generateTkv2UADAnnotationRptiNodes(doc, {
      property: subject.property,
      isComp: false,
      meta,
    }),
  );

  if (compSequence.length > 0) {
    compSequence.forEach((compId, index) => {
      const comp = comps[compId];
      if (comp) {
        reportFields.append(
          ...generateTkv2UADAnnotationRptiNodes(doc, {
            property: comp,
            isComp: true,
            meta,
            compIndex: index,
          }),
        );
      }
    });
  }

  // Add Cost Approach RPTI nodes from Subject Cost Results
  reportFields.append(...generateTkv2CostDataRptiNodes(doc, subject.costApproach));

  // Add Adjustments each comp
  compSequence.forEach((compId, index) => {
    const comp = comps?.[compId];
    if (comp) {
      reportFields.append(
        ...generateTkv2AdjustmentsRptiNodes(doc, comp, index, FormType.fnma1025, meta),
      );
    }
  });

  fnma1025.appendChild(reportFields);
  return fnma1025;
};
